import { render, staticRenderFns } from "./Devicetype.vue?vue&type=template&id=46925570&scoped=true"
import script from "./Devicetype.vue?vue&type=script&lang=js"
export * from "./Devicetype.vue?vue&type=script&lang=js"
import style0 from "./Devicetype.vue?vue&type=style&index=0&id=46925570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46925570",
  null
  
)

export default component.exports